<template>
  <div class="floating-form-actions">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'FloatingFormActions'
}
</script>

<style>
.floating-form-actions {
  background: #FFFFFF;
  bottom: 0;
  position: sticky;
  z-index: 2;
}
</style>
